import { render, staticRenderFns } from "./PlaceOrigin.vue?vue&type=template&id=64f6e8c4&scoped=true"
import script from "./PlaceOrigin.vue?vue&type=script&lang=js"
export * from "./PlaceOrigin.vue?vue&type=script&lang=js"
import style0 from "./PlaceOrigin.vue?vue&type=style&index=0&id=64f6e8c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f6e8c4",
  null
  
)

export default component.exports